<div class="modal-header">
  <div class="top">
    <div class="left-side">
      <i class="icon" [class]="formIcon"></i>

      <div class="title">
        <h2 class="h2-heading mb-0" [title]="header">{{ header }}</h2>
        <p class="sub-heading" [title]="subheader">{{ subheader }}</p>
      </div>
    </div>
    <div class="right-side">
      <div class="steps-controls">
        <ng-content select=".step-control"/>

        <button
          class="btn btn-secondary"
          [hidden]="!showSaveAndCompleteLaterBtn || currentStepIndex === 0"
          [appSpinner]="isSaveAndCompleteLaterLoading && isLoading"
          [disabled]="isLoading"
          (click)="onSaveAndCompleteLater()"
        >Save and Complete Later
        </button>

        <app-button
          iconClass="icon ic-close-20"
          btnColor="white"
          [isDisabled]="isLoading"
          (clickBtn)="closeModal()"
        />

        <app-button
          iconClass="icon ic-arrow-left-20"
          btnColor="white"
          [isDisabled]="isLoading || currentStepIndex === 0"
          (clickBtn)="setPreviousStep()"
        />

        <div class="separator"></div>

        @if (currentStepIndex < (steps.length - 1)) {
          <app-button
            #nextStepButton
            class="next-step-button"
            iconClassLast="icon ic-arrow-right-20"
            text="Next Step"
            [isDisabled]="isCurrentStepInvalid"
            (clickBtn)="setNextStep()"
          />
        } @else {
          <ng-content select=".submit-control"/>

          <app-button
            #submitButton
            class="submit-button"
            iconClass="icon ic-generate-documents-20 mr-2"
            [isDisabled]="isFormInvalid || isLoading"
            [loading]="isLoading && !isSaveAndCompleteLaterLoading"
            [text]="submitButtonText"
            (clickBtn)="confirm.emit()"
          />
        }
      </div>
    </div>
  </div>

  @if (showSteps) {
    <div class="bottom">
      <app-clickable-stepper
        [currentStepIndex]="currentStepIndex"
        [disableSteps]="isLoading"
        [steps]="steps"
        (stepIndexChange)="setCurrentStep($event)"
      />
    </div>
  }
</div>
<div class="modal-body">
  <form id="stepper-body" (submit)="$event.preventDefault(); onSubmit()">
    <app-loader minHeight="200" [loading]="isLoading"/>
    <div [hidden]="isLoading">
      <ng-content/>
    </div>
    <button class="hidden p-0" tabindex="-1" type="submit">submit</button>
  </form>

  <!-- a button which redirects focus -->
  <button class="hidden p-0" [disabled]="isLoading" (focusin)="returnFocus()"></button>
</div>

